// extracted by mini-css-extract-plugin
export default {"search":"search_search__vnhNY","box":"search_box__i-sOE"};